import { Component, Input, OnInit } from '@angular/core';
@Component({
    selector: 'simple-icons-jellyfin',
    template: `<svg class="simple-icons {{ className }}" [style.width]="size" [style.height]="size" [style.fill]="color" role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>Jellyfin icon</title><path d="M12 .002C8.826.002-1.398 18.537.16 21.666c1.56 3.129 22.14 3.094 23.682 0C25.384 18.573 15.177 0 12 0zm7.76 18.949c-1.008 2.028-14.493 2.05-15.514 0C3.224 16.9 9.92 4.755 12.003 4.755c2.081 0 8.77 12.166 7.759 14.196zM12 9.198c-1.054 0-4.446 6.15-3.93 7.189.518 1.04 7.348 1.027 7.86 0 .511-1.027-2.874-7.19-3.93-7.19z"/></svg>`,
    styles: []
})
export class SimpleIconsJellyfinComponent implements OnInit {
    @Input() size: string = '100%';
    @Input() color: string = '#00A4DC';
    @Input() className: string = 'simple-icons-jellyfin'
    constructor() {}
    ngOnInit(): void {}
}
